/// <reference path='../../../typings/browser.d.ts' />

namespace Application.Controllers {
  'use strict';

  import ConnectionRoom = Models.ConnectionRoom;
  import IBlock = Application.Models.IBlock;
  import INetworkNode = Application.Models.NetworkNode;

  export interface IMonitorProbeModalScope extends ng.IScope {
    blocksInfo: IBlock[] | any; // source and sink block
    rtspUrl: string;
    modalClose: () => void;
    getMonitorDevices: () => void;
    loading: boolean;
    monitorDevices: Models.NetworkNode[];
    allDevices: Models.NetworkNode[];
    monitorDevicesForRtsp: Models.NetworkNode[];
    monitorBlocks: IBlock[] | any;
    setMonitor: (block: IBlock) => void;
    stopMonitor: (block: IBlock) => void;
  }

  /**
   * MonitorProbeController class
   */
  export class MonitorRtspController {
    public static templateURL: string = 'decorators/modals/monitor-rtsp-modal.html';
    public static ID: string = '#id-monitor-rtsp-modal';
    public static $name: string = 'monitorRtspModalController';
    public connectionRooms: ConnectionRoom[];
    public static $inject: string[] = [
      '$scope',
      'close',
      '$timeout',
      'blocksInfo',
      'rtspUrl',        
      'networkNodeService',
      'blockService',
      'streamPipeService'
    ];

    private scope: IMonitorProbeModalScope;
    private close: (parameters: ngModal.ICloseParameters) => void;

    /**
     * Constructor
     */
    constructor(
      $scope: IMonitorProbeModalScope,
      close: (parameters: ngModal.ICloseParameters) => void,
      $timeout: ng.ITimeoutService,
      blocksInfo: IBlock[],
      rtspUrl: string,
      private networkNodeService: Services.NetworkNodeService,
      private blockService: Services.BlockService,
      private streamPipeService: Services.StreamPipeService,
    ) {
      this.scope = $scope;
      this.scope.loading = false;
      this.scope.blocksInfo = blocksInfo;
      this.scope.rtspUrl = rtspUrl;

      $timeout(() => {
        window.altair_admin_common_init();
      }, 500);

      this.close = close;

      this.scope.modalClose = (): void => {
        this.close(undefined);
      };

      this.scope.setMonitor = (block: IBlock): void => {
        this.setMonitor(block);
      };

      this.scope.stopMonitor = (block: IBlock): void => {
        this.stopMonitor(block);
      };

      this.getMonitorDevices();

    }

    async getMonitorDevices(){
      this.scope.monitorDevices = await this.networkNodeService.getMonitorNodes();
      this.getMonitorBlocksForRtsp();
    }

    async getMonitorBlocksForRtsp(){
      this.scope.loading = true;
      this.scope.monitorBlocks = await this.blockService.getMonitorBlocks(this.scope.monitorDevices);
      this.scope.loading = false;
    }

    setMonitor(block: IBlock){
      this.scope.loading = true;
      console.log(JSON.stringify(block));
      this.setUrlInDevice(block);
      this.setMonitorFlagInBlock(block);
    }
    
    // update url field in MVP device
    setUrlInDevice(block: IBlock){
      //change to set RTSP url from server
      //console.log("srtUrl: ", this.scope.srtUrl);
      this.streamPipeService.setMvpMonitorUrl(block.id, this.scope.rtspUrl);
    }

    /**
     * Identify block as a monitor block
     */
    setMonitorFlagInBlock(block: IBlock){
      block.config.monitoring = this.scope.blocksInfo[1].blockConnection.destBlock.id;
      block.config.monitoringName = this.scope.blocksInfo[1].blockConnection.destBlock.name;
      this.blockService.updateBlock(block).then( (res: any)=> {
        this.scope.loading = false;
      });
    }

    stopMonitor(block: IBlock){
      this.scope.loading = true;
      this.unsetUrlInDevice(block);
      this.unsetMonitorFlagInBlock(block);
    }

    unsetMonitorFlagInBlock(block: IBlock){
      delete block.config.monitoring;
      this.blockService.updateBlock(block).then( (res: any)=> {
        this.scope.loading = false;
      });
    }

    unsetUrlInDevice(block: IBlock){
      this.streamPipeService.unsetMvpMonitorUrl(block.id);
    }

  }
}
